import {useMemo} from 'react';
import styled from 'styled-components';
import {PointCoords} from '@/map/@types';
import {ANAYSIS_RESULT_LABELS} from '@/map/constants';
import {AreaAnalyticsFilter, BuildingType} from '@/map/enums';
import {Marker, StaticMarker} from '@/map/modules';
import {convertToCoordFromPointCoords, getHouseMarkerInfo, getHouseMarkerSize} from '@/map/utils';
import {interceptProps} from '@/styled-components';
import {RoundColorMarker} from '../RoundColorMarker';

interface IProps extends IContentProps {
  map: naver.maps.Map;
  visible?: boolean;
  isSimple?: boolean;
}

interface IContentProps {
  type: BuildingType | AreaAnalyticsFilter;
  item: {
    location: {
      coordinates: PointCoords;
    };
    count?: number;

    // 아파트 입주 예정
    name?: string;
    date?: string;
  };
}

export const HouseMarker = ({
  map,
  type,
  item,
  visible = true,
  isSimple,
}: IProps) => {
  const position = useMemo(
    () => convertToCoordFromPointCoords(item.location.coordinates),
    [item?.location?.coordinates]
  );

  if (!map || !position) {
    return null;
  }

  const markerInfo = getHouseMarkerInfo(type);
  const count = item.count ?? 0;
  const isMoveIn = type === AreaAnalyticsFilter.UPCOMMING_APTS;

  if (isSimple) {
    return (
      <StaticMarker
        map={map}
        draggable={false}
        clickable={false}
        position={position}
      >
        <Round size={getHouseMarkerSize(count)} color={markerInfo?.color} />
      </StaticMarker>
    );
  }

  if (count < 200) {
    return (
      <Marker
        map={map}
        draggable={false}
        clickable={false}
        position={position}
        visible={visible}
      >
        <Round size={getHouseMarkerSize(count)} color={markerInfo?.color} />
      </Marker>
    );
  }

  const name = isMoveIn ? '예' : ANAYSIS_RESULT_LABELS[type] || '';
  const detailName = isMoveIn && [
    item.name || '',
    item.date ? item.date : '(입주 예정)',
  ];

  return (
    <RoundColorMarker
      contentInfo={{
        name,
        color: markerInfo?.color,
      }}
      item={{
        count,
        name: detailName || '',
      }}
      config={{
        visible,
        position,
        map,
      }}
    />
  );
};

const Round = styled('div').withConfig({
  shouldForwardProp: interceptProps(['color', 'size']),
})<{
  color: string;
  size: number;
}>`
  border-radius: 100%;
  ${({color, size}) => `
    background-color: ${color};
    width: ${size}px;
    height: ${size}px;
  `}
`;
